import React, { useEffect } from 'react'
import Box from '@material-ui/core/Box'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from 'components/material-symbol/icons/Close'
import DialogContent from '@material-ui/core/DialogContent'
import MuiDialog from '@material-ui/core/Dialog'
import Typography from '@material-ui/core/Typography'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button'
import { makeStyles } from '@material-ui/core/styles'
import CelebrationOutlinedIcon from 'components/material-symbol/icons/Celebration'
import SectionEmptyState from 'components/section-empty-state'
import { gtmEvent } from 'lib/gtm'

const useStyles = makeStyles(theme => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(1, 1, 0),
  },
  headerTitleOnly: {
    justifyContent: 'flex-end',
    paddingBottom: 0,
  },
  dialogTitle: {
    flex: 1,
    padding: theme.spacing(2, 2, 1),
  },
  content: {
    paddingTop: theme.spacing(1),
  },
  completionContent: {
    paddingTop: 0,
    paddingBottom: theme.spacing(3),
  },
  legacyActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(5),
  },
  actionButton: {
    borderRadius: 20,
    textTransform: 'none',
    fontWeight: 700,
    padding: theme.spacing(1.25, 3),
  },
}))

const OnboardingDialog = ({
  heading,
  title,
  caption,
  text,
  children,
  open,
  onClose,
  action = false,
  scheduleDialog = false,
}) => {
  const classes = useStyles()
  const useCompletionState = Boolean(title)

  useEffect(() => {
    if (open && !scheduleDialog) {
      gtmEvent({
        event: 'onboarding-step-completed',
      })
    }
  }, [open, scheduleDialog])

  const backToOnboardingButton = action ? (
    <Button
      variant="contained"
      color="primary"
      size="large"
      className={classes.actionButton}
      onClick={() => {
        window.location.href = '/pga-coach'
      }}
    >
      Back to Onboarding
    </Button>
  ) : null

  return (
    <MuiDialog maxWidth="sm" fullWidth open={open} onClose={onClose}>
      <Box
        className={`${classes.header} ${
          useCompletionState ? classes.headerTitleOnly : ''
        }`}
      >
        {!useCompletionState && heading ? (
          <DialogTitle className={classes.dialogTitle}>{heading}</DialogTitle>
        ) : null}
        <IconButton aria-label="Close" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent
        dividers
        className={
          useCompletionState ? classes.completionContent : classes.content
        }
      >
        {useCompletionState ? (
          <SectionEmptyState
            Icon={CelebrationOutlinedIcon}
            title={title}
            caption={caption}
            bordered={false}
            action={backToOnboardingButton}
          />
        ) : (
          <>
            {text ? (
              <Box mb={2}>
                <Typography variant="body1" color="textSecondary">
                  {text}
                </Typography>
              </Box>
            ) : null}
            {children}
            {action ? (
              <Box className={classes.legacyActions}>
                {backToOnboardingButton}
              </Box>
            ) : null}
          </>
        )}
      </DialogContent>
    </MuiDialog>
  )
}

export default OnboardingDialog
